export const CCurrencyTypes = [
  { label: "USD", value: "us" },
  { label: "DOP", value: "rd" },
];